import { LocalDate } from "../../../shared/jsr310-localdates/types/local-date.type";
import { TypeDocumentPa } from "./document-pa.entity";

export class DocEchangeUpdateStepOrder {
	id!: number;
	documentEchanges!: DocumentEchangeUpdateOrder[];
	presentationSite!: PresentationSite;
	
	constructor(idPa: number) {
		this.id = idPa;
		this.presentationSite = new PresentationSite();
		this.documentEchanges = [];
	}
}

export class DocumentEchangeUpdateOrder {
	id!: number;
	checked!: boolean; 
}

export class PresentationSite {
	id!: number;
	dateRealisation!: number[] | LocalDate | null;
	type!: TypeDocumentPa;
	zoneAccesInterdit!: string;
	particulariteInstallation!: string;
	conduiteATenir!: string;
}